export default __webpack_public_path__ + "static/media/ic_new_link_16.5b7cb7bf.svg";